module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "加减课时"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 80,
      "model": _vm.classHourParam,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.showUid) ? _c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "学生id",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入学生id"
    },
    model: {
      value: (_vm.classHourParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "uid", _vm._n($$v))
      },
      expression: "classHourParam.uid"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类别",
      "prop": "class"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "transfer": ""
    },
    model: {
      value: (_vm.classHourParam.courseType),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "courseType", _vm._n($$v))
      },
      expression: "classHourParam.courseType"
    }
  }, _vm._l((_vm.$constant.newCourseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "加减课时数量",
      "prop": "num"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入课时数"
    },
    model: {
      value: (_vm.classHourParam.num),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "num", _vm._n($$v))
      },
      expression: "classHourParam.num"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 80,
      "label": "赠课类型",
      "prop": "givingType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择类型",
      "clearable": ""
    },
    on: {
      "on-change": _vm.changeGivingType
    },
    model: {
      value: (_vm.classHourParam.givingType),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "givingType", _vm._n($$v))
      },
      expression: "classHourParam.givingType"
    }
  }, _vm._l((_vm.$constant.givingType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.classHourParam.givingType === 2 || _vm.classHourParam.givingType === 3 ||
    _vm.classHourParam.givingType === 5 || _vm.classHourParam.givingType === 6 || _vm.classHourParam.givingType === 7) ? _c('Form-item', {
    attrs: {
      "label": "子类型",
      "prop": "givingTypeChild"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.classHourParam.givingTypeChild),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "givingTypeChild", _vm._n($$v))
      },
      expression: "classHourParam.givingTypeChild"
    }
  }, _vm._l((_vm.givingTypeChild), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.classHourParam.givingType === 2) ? _c('FormItem', {
    attrs: {
      "label": "被推荐人",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "学生ID"
    },
    model: {
      value: (_vm.classHourParam.inviteUid),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "inviteUid", $$v)
      },
      expression: "classHourParam.inviteUid"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.classHourParam.givingType === 1 || _vm.classHourParam.givingType === 2 || _vm.classHourParam.givingType === 4 || _vm.classHourParam.givingType === 6 || _vm.classHourParam.givingType === 7 || _vm.classHourParam.givingType === 11 || _vm.classHourParam.givingType === 12) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传凭证",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.classHourParam.url),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "url", $$v)
      },
      expression: "classHourParam.url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.classHourParam.givingType === 4 || _vm.classHourParam.givingType === 5 || _vm.classHourParam.givingType === 6) ? _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "老师",
      "prop": "tchId"
    }
  }, [_c('TeacherSelect', {
    staticStyle: {
      "width": "143px"
    },
    attrs: {
      "category": [1, 2]
    },
    model: {
      value: (_vm.classHourParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "tchId", _vm._n($$v))
      },
      expression: "classHourParam.tchId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.classHourParam.givingType === 4) ? _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "上课时间",
      "prop": "classTime",
      "required": ""
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "value": _vm.classHourParam.classTime
    },
    on: {
      "on-change": _vm.classTimeDateChange
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原因",
      "prop": "reason"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.classHourParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.classHourParam, "reason", $$v)
      },
      expression: "classHourParam.reason"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5dda87e6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserClassHourModal.vue
// module id = 1832
// module chunks = 8